import React, { useEffect } from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { DealPipelineView } from '@/components/views/DealPipelineView';

export const ClaimsPage = () => {

	return (<AuthenticatedPageLayout>
		<DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_CLAIMS}/>
	</AuthenticatedPageLayout>);
};